/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ months: NonNullable<unknown> }} Admin_Billing_Batch_Month_SingularInputs */

const es_admin_billing_batch_month_singular = /** @type {(inputs: Admin_Billing_Batch_Month_SingularInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.months} mes`)
};

const en_admin_billing_batch_month_singular = /** @type {(inputs: Admin_Billing_Batch_Month_SingularInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.months} month`)
};

/**
* | output |
* | --- |
* | "{months} month" |
*
* @param {Admin_Billing_Batch_Month_SingularInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_month_singular = /** @type {((inputs: Admin_Billing_Batch_Month_SingularInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_Month_SingularInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_month_singular(inputs)
	return en_admin_billing_batch_month_singular(inputs)
});
export { admin_billing_batch_month_singular as "admin.billing.batch.month_singular" }